module.exports = __webpack_public_path__ + "img/recycling@2x.4eb52af.jpg";